<template>
    <div>
        <h1>Lizensen</h1>
    </div>
</template>
<script>
export default {
    name: 'license-view',
    beforeRouteEnter (to, from, next) { 
        next(vm => { 
            vm.$socket.emit('get-licenses', )
            next();
        }) 
    },
    data(){
        return{

        }
    }
}
</script>